import { Typography } from "@drpcrd/shared/ui";
import { cn } from "@drpcrd/utils";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
};

/**
 * Small uppercase, letter-spaced label that sits above a section heading.
 */
export const SectionEyebrow = ({ children, className }: Props) => (
  <Typography
    size="xs"
    color="black"
    className={cn("tracking-[2px]", className)}
  >
    {children}
  </Typography>
);
